import React, { useEffect, useState } from 'react';

const EVENT_DATE = new Date(2026, 8, 4, 0, 0, 0);

function getTimeLeft() {
  const diff = EVENT_DATE.getTime() - Date.now();
  if (diff <= 0) return null;
  return {
    days:    String(Math.floor(diff / 86400000)).padStart(2, '0'),
    hours:   String(Math.floor((diff % 86400000) / 3600000)).padStart(2, '0'),
    minutes: String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0'),
    seconds: String(Math.floor((diff % 60000) / 1000)).padStart(2, '0'),
  };
}

export default function TopbarCountdown() {
  const [left, setLeft] = useState(getTimeLeft);

  useEffect(() => {
    const t = setInterval(() => setLeft(getTimeLeft()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!left) {
    return (
      <div className="tcd-pill tcd-live">
        <span>🎉</span>
        <span className="tcd-live-text">Offsite is LIVE!</span>
      </div>
    );
  }

  return (
    <div className="tcd-pill">
      <div className="tcd-label">
        <span className="tcd-dot" />
        <span>Sep 4</span>
      </div>
      <div className="tcd-sep-v" />
      <div className="tcd-units">
        <Chip value={left.days}    label="D" />
        <span className="tcd-colon">:</span>
        <Chip value={left.hours}   label="H" />
        <span className="tcd-colon">:</span>
        <Chip value={left.minutes} label="M" />
        <span className="tcd-colon">:</span>
        <Chip value={left.seconds} label="S" key-sec={left.seconds} />
      </div>
    </div>
  );
}

function Chip({ value, label }) {
  return (
    <div className="tcd-chip">
      <span key={value} className="tcd-num">{value}</span>
      <span className="tcd-unit-lbl">{label}</span>
    </div>
  );
}
